import React from "react";
import Chapter from "@/components/landing/Chapter";
import Reveal from "@/components/landing/Reveal";
import { IMAGES } from "@/lib/landingConfig";
import { useLandingImages } from "@/lib/ImagesContext";

/**
 * Community — a full-bleed editorial photograph that gives visual proof of
 * "112 mujeres líderes participantes". Intentionally kept quiet in typography
 * so the image itself is the story.
 */
const Community = () => {
  const { bySlot } = useLandingImages();
  const img = bySlot["community"] || IMAGES.communityPhoto;

  return (
    <section
      id="comunidad"
      data-testid="community-section"
      className="bg-[#FAF8F3]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 lg:py-32">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-end mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-7">
            <Reveal>
              <Chapter number="02" label="Comunidad viva" />
              <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[#3F403A]">
                La sala es solo el inicio.
                <br />
                <span className="italic text-[#63846F]">La comunidad es lo que permanece.</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-5">
            <Reveal delay={140}>
              <p className="font-sans text-base md:text-lg leading-relaxed text-[#3F403A]/80">
                Mujeres empresarias, directivas y profesionales que hoy comparten
                decisiones, alianzas y presencia en medios. Este es el ecosistema
                que sostienen edición tras edición.
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={80}>
          <figure
            className="relative overflow-hidden bg-[#F4EFE7]"
            style={{ aspectRatio: "3/2" }}
            data-testid="community-photo"
          >
            {img ? (
              <img
                src={img}
                alt="Comunidad Lidera con Voz Propia — participantes de la última edición"
                className="h-full w-full object-cover"
                loading="lazy"
              />
            ) : (
              <div className="absolute inset-0 flex items-center justify-center">
                <p className="font-serif text-2xl text-[#3F403A]/50">
                  Fotografía de comunidad
                </p>
              </div>
            )}
            {/* thin editorial frame */}
            <div className="pointer-events-none absolute inset-0 border border-[#3F403A]/10" />
          </figure>
        </Reveal>

        <Reveal delay={160}>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
            <p className="overline text-[#3F403A]/60">
              Edición anterior · Lidera con Voz Propia
            </p>
            <p className="font-serif italic text-lg md:text-xl text-[#3F403A]/75 max-w-md sm:text-right">
              “La calidad de la sala no se mide en asistentes, se mide en
              decisiones compartidas.”
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Community;
